import type * as React from "react";

import { cx } from "../../cx";
import styles from "./skeleton.module.css";

export type SkeletonVariant =
  | "title"
  | "text"
  | "label"
  | "meta"
  | "control-sm"
  | "control"
  | "control-lg"
  | "badge"
  | "avatar"
  | "square"
  | "icon"
  | "block"
  | "tile";

type SkeletonProps = React.ComponentProps<"div"> & {
  variant?: SkeletonVariant;
  as?: "div" | "span";
};

function Skeleton({
  className,
  as: As = "div",
  variant,
  ...props
}: SkeletonProps) {
  return (
    <As
      data-tui=""
      data-slot="skeleton"
      data-variant={variant}
      aria-hidden
      className={cx(styles.skeleton, className)}
      {...props}
    />
  );
}

export { Skeleton };
